export default {
  heading: {
    id: 'checkout_bouygues_magic_link_layout_error_heading',
    defaultMessage: 'Votre panier vous attend',
  },
  firstParagraph: {
    id: 'checkout_bouygues_magic_link_layout_error_first_paragraph',
    defaultMessage: "Pas d'inquiétude, votre panier est toujours disponible.",
  },
  secondParagraph: {
    id: 'checkout_bouygues_magic_link_layout_error_second_paragraph',
    defaultMessage:
      'Pour finaliser votre achat, cliquez à nouveau sur le lien reçu par e-mail ou par SMS.',
  },
  bouyguesIcon: {
    id: 'checkout_header_in_store_bouygues_telecom_icon',
    defaultMessage: 'Bouygues Telecom',
  },
}
